import React from "react";
import { useAppSelector } from "../../app/hooks";
import SubscriptionDashboard from "./SubscriptionDashboard";
import SubscriptionsManagementPage from "./SubscriptionsManagementPage";

/**
 * Conditional subscription page that shows:
 * - SubscriptionsManagementPage for SuperAdmin (list of all subscriptions)
 * - SubscriptionDashboard for Admin and other roles (user's own subscription)
 */
const SubscriptionPage: React.FC = () => {
  const user = useAppSelector((state) => state.auth.user);
  const isSuperAdmin = user?.role === "SuperAdmin";

  if (isSuperAdmin) {
    return <SubscriptionsManagementPage />;
  }

  return <SubscriptionDashboard />;
};

export default SubscriptionPage;
